<template>
<div id="katalog-tiket">
    <ol class="breadcrumb pull-right">
        <li>
            <router-link :to="{path: '/'}">Home</router-link>
        </li>
        <li>Voucher</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">Kode Voucher</h1>
    <!-- end page-header -->
    <div class="row">
        <div class="col-md-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
                <div class="panel-heading">
                    <div class="pull-right">
                        <button type="button" class="btn btn-success btn-xs m-r-5" @click="$router.push('/voucher/form')"><span class="fa fa-plus"></span> Tambah Voucher</button>
                    </div>
                    <h4 class="panel-title">List Kode Voucher</h4>
                </div>
                <div class="panel-body">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-3">
                                <select v-model="channelSelected" class="form-control">
                                    <option value="" disabled selected>Filter By Channel</option>
                                    <option v-for="(item, i) in listChannel" :key="i" :value="item.id">{{ item.name}}</option>
                                </select>
                            </div>
                            <div class="col-md-3">
                                <!-- <select v-model="productSelected" class="form-control">
                                    <option value="" disabled selected>Filter By Produk</option>
                                    <option v-for="(item, i) in productList" :key="i" :value="item.value">{{ item.text}}</option>
                                </select> -->
                                <model-select :options="productList"
                                                        v-model="productSelected"
                                                        placeholder="Filter By Product">
                                </model-select>
                            </div>
                            <div class="col-md-2">
                                <select v-model="sortSelected" class="form-control">
                                    <option value="" disabled selected>Sort By Inventori</option>
                                    <option value="ASC">Ascending</option>
                                    <option value="DESC">Descending</option>
                                </select>
                            </div>
                            <div class="col-md-2" v-if="channelSelected || productSelected || sortSelected">
                                <button @click="clearFilter()" class="btn btn-danger btn-md">Clear Filter</button>
                            </div>
                        </div>
                    </div>
                    <app-datatable 
                    :has-soldout-warning="true"
                    :items="voucherList"
                    :has-action="true"
                    :has-add-quota="true"
                    :has-search-power="false"
                    :has-delete="false"
                    :has-custom-pagination="true"
                    :custom-pagination-current-page="currentPage"
                    :custom-pagination-per-page="paging.limit"
                    :custom-pagination-total-pages="paging.total_page"
                    :custom-pagination-sort-mode="pagination.sortMode"
                    :headers="headers"
                    v-on:addQuota="addQuota($event)"
                    v-on:doSearch="search = {query: $event.value, by: headersKey[$event.key]}" />
                    <div >
                      <div class="btn-group pull-left">
                        <button class="btn btn-white" type="button">Total Page:</button>
                        <button class="btn btn-white" type="button"> {{ paging.total_page }} </button>
                      </div>
                      <div class="btn-group pull-right" v-if="paging.total_page > 1">
                        <button class="btn btn-white" type="button" :disabled="currentPage == 1" @click="changePage(-1)">
                          Previous
                        </button>
                        <input type="number" v-model="currentPage" min="1" readonly :max="paging.total_page" >
                        <button class="btn btn-white" type="button" :disabled="currentPage == paging.total_page" @click="changePage(1)">
                          Next
                        </button>
                      </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModal" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Tambah Kuota</h5>
                </div>
                <div class="modal-body">
                    <div class="row m-5">
                        <div class="col-md-4">Nama Channel</div>
                        <div class="col-md-8">: <b>{{voucherSelected.data[0]}} </b></div>
                    </div>
                    <div class="row m-5">
                        <div class="col-md-4">Nama Product</div>
                        <div class="col-md-8">: <b style="word-break:break-all !important;">{{voucherSelected.data[1]}} </b></div>
                    </div>
                    <div class="row m-5">
                        <div class="col-md-8">Tambah Kuota (Kuota Saat ini: {{voucherSelected.data[2]}})</div>
                        <div class="col-md-12">
                            <input type="number" class="form-control" min="1" @click="quota = ''" v-model="quota" style="max-width:100px; margin-top:10px;" />
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" @click="changeQuota()" class="btn btn-success">Tambah Kuota</button>
                    <button type="button" @click="$('#myModal').modal('hide')" class="btn btn-danger" data-dismiss="modal">Batal</button>
                </div>
            </div>
        </div>
    </div>
    <app-spinner v-if="isLoading"></app-spinner>
</div>
</template>

<script>
import DataTable from '@/components/plugins/DataTable'
import Spinner from '@/components/plugins/Spinner'
import SalesService from '@/services/sales.js'
import VoucherService from '@/services/voucher.js'
import FileService from '@/services/file.js'
import 'vue-search-select/dist/VueSearchSelect.css'
import { ModelSelect } from 'vue-search-select'
export default {
    name: 'katalog-tiket',
    components: {
        'app-datatable': DataTable,
        'app-spinner': Spinner,
        'model-select': ModelSelect
    },
    data: function () {
        return {
            isLoading: false,
            productList: [],
            productSelected: '',
            voucherList: [],
            listChannel: '',
            quota: 0,
            channelSelected: '',
            voucherSelected: {
                data: ['', '', '']
            },
            sortSelected: '',
            selectedRow: null,
            search: null,
            pagination: {
                perPage: 25,
                currentPage: 1,
                totalPages: 0,
                sortMode: 'ASC',
            },
            paging: {
              limit: 0,
              page: 0,
              total_data: 0,
              total_page: 0
            },
            currentPage: 1,
            maxPage: null,
            type: {
                // SCHEDULED_TRYOUT: 'SCHEDULED_TRYOUT',
                // INSTANT_TRYOUT: 'INSTANT_TRYOUT',
                // CONSULTATION: 'CONSULTATION',
                // DUEL: 'DUEL',
                // ITEM_BANK: 'ITEM_BANK',
                // VIDEO: 'VIDEO'
            },
            headers: ['E-Commerce Channel', 'Product', 'Inventori'],
            headersKey: ['judul', 'type', 'status'],
            totalPage: 0
        }
    },
    mounted: function () {
        this.fetchData()
        this.getProdukList()

    },
    watch: {
        pagination: function () {
          this.currentPage = 1
          this.fetchData()
        },
        channelSelected: function () {
          this.currentPage = 1
          this.fetchData()
        },
        productSelected: function () {
          this.currentPage = 1
          this.fetchData()
        },
        sortSelected: function () {
          this.currentPage = 1
          this.fetchData()
        }
    },
    methods: {
        clearFilter: function () {
            var context = this
            if(context.channelSelected != '') context.channelSelected = ''
            if(context.productSelected != '' ) context.productSelected = ''
            if(context.sortSelected != '' ) context.sortSelected = ''
        },
        addQuota: function (item) {
            var context = this
            context.voucherSelected = item
            $('#myModal').modal('show')
        },
        changePage: function(v) {
          var context = this
          context.currentPage = context.currentPage + (v)
          context.fetchData()
        },
        fetchData: function () {
            var context = this
            var search = {}
            if (context.channelSelected != '') search.channel_id = context.channelSelected
            if (context.productSelected != '') search.product_id = context.productSelected
            var pagination = {
                perPage: 25,
                currentPage: context.currentPage,
                sortMode: context.sortSelected
            }

            this.isLoading = true

            VoucherService.getListVoucher(pagination, search, function (result) {
                context.voucherList = []
                context.isLoading = false
                if (result.success) {
                    var pg = result.pagination
                    context.paging = {
                      limit: pg.limit,
                      page: pg.page,
                      total_data: pg.total_data,
                      total_page: pg.total_page
                    }
                    result.data.forEach(function (content) {
                        var row = {
                            data: [
                                content.channel_name,
                                content.product_name,
                                content.total_voucher
                            ],
                            channel_id: content.channel_id,
                            product_id: content.product_id
                        }
                        // context.pagination.totalPages = content.total_page
                        context.voucherList.push(row)

                    })
                } else {
                    alert('Terjadi Kesalahan : ' + result.data.message)
                }
            })
        },
        getProdukList: function () {
            var context = this
            var search = {query: 'PUBLISHED', by: 'status'}
            var pagination = {
                perPage: 1000,
                currentPage: 1,
                sortMode: 'ASC',
            }

            // this.isLoading = true
            VoucherService.getListChannels(pagination, '', function (result) {
                context.listChannel = result.data
            })
            SalesService.getProdukList(pagination, search, function (result) {
                // context.produkList = []
                // context.isLoading = false

                if (result.success) {
                    result.data.forEach(function (content) {
                        var row = {
                            text: content.title.toLowerCase(),
                            value: content.id
                        }
                        context.productList.push(row)
                    })
                    context.productList.sort((a, b) => {
                        if (a.text < b.text)
                            return -1;
                        if (a.text > b.text)
                            return 1;
                        return 0;
                    })
                } else {
                    alert('Terjadi kesalahan : ' + result.message)
                }
            })
        },
        downloadGeneratedFile: function (path) {
            var context = this
            FileService.download2(path, function (response) {
                console.log(response)
            })
            context.fetchData()
            context.loading = false
        },
        changeQuota: function () {
            var context = this
            
            if(context.quota < 1 ) {
              alert('Jumlah kuota tidak valid')
              return false
            } else {
              context.isLoading = true
              $('#myModal').modal('hide')
              var body = {
                  channel_id: context.voucherSelected.channel_id,
                  products: [{
                      product_id: context.voucherSelected.product_id,
                      amount: context.quota
                  }]
              }
              VoucherService.generateVoucher(body, function (result) {
                
                  if (result.success) {
                      context.downloadGeneratedFile(result.data.directory)
                      alert('voucher berhasil di generate')
                  } else {
                      alert('Terjadi kesalahan: ' + result.message)
                  }
                  context.isLoading = false
              })
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// Voucher.vue?2a18f329